module.exports = __webpack_public_path__ + "img/肌如初雪套装_01.f3439098.jpg";